import React, { PureComponent, MouseEventHandler } from 'react';
import _ from 'lodash';
import classNames from 'classnames';
type ButtonProps = {
  primary?: boolean;
  secondary?: boolean;
  danger?: boolean;
  large?: boolean;
  disabled?: boolean;
  onClick?: MouseEventHandler;
  className?: string;
  children?: React.ReactNode;
};

export default class Button extends PureComponent<ButtonProps> {
  static defaultProps = {
    primary: false,
    secondary: false,
    danger: false,
    large: false,
    disabled: false,
    onClick: _.noop
  };
  render () {
    const {
      primary,
      secondary,
      danger,
      large,
      disabled,
      onClick: handleClick,
      className: parentClassName
    } = this.props;
    const className = classNames(parentClassName, {
      btn: true,
      'btn-primary': primary,
      'btn-secondary': secondary,
      'btn-danger': danger,
      'btn-lg': large,
      'btn-sm': !large
    });
    return (
      <button type='button' className={className} onClick={handleClick} disabled={disabled}>
        {this.props.children}
      </button>
    );
  }
}
